<template>
  <v-container>
    <v-row>
      <v-col
        v-for="activity in activities"
        :key="activity.id"
        cols="4"
      >
        <v-card
          shaped
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline">{{ activity.title }}</v-list-item-title>
              <v-list-item-subtitle>by {{ activity.author_name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-img
            src="@/assets/img/kitchen-cuttingboard.webp"
            height="194"
          ></v-img>

          <v-card-subtitle>
            <v-text-field
              label="Starts at:"
              :value="activity.start_time | formatDate"
              type="datetime"
              prepend-icon="mdi-alarm"
              suffix="GMT+4"
              readonly
              rounded
              dense
              outlined
            ></v-text-field>
          </v-card-subtitle>

          <v-card-text class="text-truncate">{{ activity.description }}</v-card-text>

          <v-card-text>
            <v-chip-group
              multiple
              active-class="primary--text"
            >
              <v-chip v-for="tag in activity.tags" :key="tag">
                {{ tag }}
              </v-chip>
            </v-chip-group>
          </v-card-text>

          <v-card-actions>
            <v-btn
              text
              rounded
              color="lime accent-4"
              :to="/activity/ + activity.id"
              :activityId="activity.id"
            >
              View Activity
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-badge
                color="grey"
                :content="activity.hearts_count"
                left
              >
                <v-icon v-if="activity.current_user_heart">mdi-heart</v-icon>
                <v-icon v-else>mdi-heart-outline</v-icon>
              </v-badge>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CardsList',
  methods: {
    ...mapActions(['fetchActivities'])
  },
  computed: mapGetters(['activities']),
  created() {
    this.fetchActivities()
  }
}
</script>